import React from "react";
import { Box, Container, Typography, Stack } from "@mui/material";
import ImgPath from "../../Constants/Imgs";

const partnerLogos = [
  {
    src: ImgPath.OyoIcon,
    alt: "OYO",
  },
  {
    src: ImgPath.SwiggyIcon,
    alt: "Swiggy",
  },
  {
    src: ImgPath.BigBasketIcon,
    alt: "BigBasket",
  },
  {
    src: ImgPath.HDFCIcon,
    alt: "HDFC Bank",
  },
  {
    src: ImgPath.AmazonIcon,
    alt: "Amazon",
  },
];

const PartnerSection = () => {
  return (
    <Box
      component="section"
      className="partner-section section-wrap"
      sx={{ bgcolor: "#F3EAE0", py: 6 }}
    >
      <Container sx={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          className="section-heading partner-title"
          gutterBottom
        >
          Partner With Us
        </Typography>
        <Stack
          direction="row"
          flexWrap="wrap"
          justifyContent="center"
          alignItems="center"
          spacing={4}
          sx={{ py: 3 }}
        >
          {partnerLogos.map((logo, index) => (
            <Box
              key={index}
              component="img"
              src={logo.src}
              alt={logo.alt}
              sx={{ maxWidth: 100 }}
            />
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

export default PartnerSection;
